import { render, staticRenderFns } from "./msgs_detail.vue?vue&type=template&id=5d241387"
import script from "./msgs_detail.vue?vue&type=script&lang=js"
export * from "./msgs_detail.vue?vue&type=script&lang=js"
import style0 from "./msgs_detail.vue?vue&type=style&index=0&id=5d241387&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports